import { boolean, number, object, string } from "superstruct";

const GiftRegistryTypeSchema = object({
    id: number(),
    name: string(),
    isEnabled: boolean(),
});

export default GiftRegistryTypeSchema;
